import type { auth as EN } from '../en/auth';

export const auth: Record<keyof typeof EN, string> = {
  'auth.login.title': 'Anmelden',
  'auth.login.username': 'Benutzername',
  'auth.login.password': 'Passwort',
  'auth.login.submit': 'Anmelden',
  'auth.session.expired':
    'Deine Sitzung ist abgelaufen. Melde dich an, um weiter zu synchronisieren.',
  'auth.login.appName': 'Notizbuch',
  'auth.login.subtitle': 'Melde dich bei deinem Notizbuch an.',
  'auth.login.submitting': 'Anmeldung läuft…',
  'auth.login.submitLocked': 'Erneut versuchen in {countdown}',
  'auth.login.lockout': 'Zu viele Versuche. Erneut versuchen in {countdown}.',
  'auth.login.error.badCredentials': 'Falscher Benutzername oder falsches Passwort.',
  'auth.login.error.network':
    'Anmeldung nicht möglich. Prüfe deine Verbindung und versuche es erneut.',
  'auth.login.error.validation': 'Gib einen Benutzernamen und ein Passwort ein.',
  'auth.login.error.generic': 'Anmeldung nicht möglich.',
  'auth.boot.loading': 'Wird geladen',
  'auth.offline.title': 'Der Server ist nicht erreichbar.',
};
